/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { toggleTimePeriodSelection } from "src/redux/features/insights-filter/insightsFilterSlice";

/* Ionic */
import { IonItem, IonIcon } from "@ionic/react";

import {
  ellipseOutline,
  radioButtonOnOutline,
} from "ionicons/icons";

/* Stylesheet */
import styles from "./TimePeriodDropdown.module.scss";

/* Interfaces */
import { TimePeriodType } from "src/shared/interfaces/insights-filter/InsightsFilter";

const TimePeriodDropdown: React.FC = () => {
  const dispatch = useDispatch();

  const insightsFilterState = useSelector(
    (state: RootState) => state.insightsFilter
  );

  const { timePeriod } = insightsFilterState;
  const { value, initialValue } = timePeriod!;

  const firstYear =
    value?.firstYear ?? initialValue?.firstYear;
  const lastYear =
    value?.lastYear ?? initialValue?.lastYear;

  const isFirstYearChanged =
    value?.firstYear !== initialValue?.firstYear;
  const isLastYearChanged =
    value?.lastYear !== initialValue?.lastYear;

  return (
    <React.Fragment>
      <div className={styles.dropdown_item}>
        <div className={styles.label}>First year</div>
        <IonItem
          className={styles.item}
          lines="none"
          button
          disabled={!isFirstYearChanged}
          onClick={() =>
            dispatch(
              toggleTimePeriodSelection(
                TimePeriodType.FIRST_YEAR
              )
            )
          }
        >
          <div className={styles.year}>
            <IonIcon
              className={styles.icon}
              icon={
                !value?.firstYear
                  ? ellipseOutline
                  : radioButtonOnOutline
              }
            />
            {firstYear}
          </div>
        </IonItem>
      </div>
      <div className={styles.dropdown_item}>
        <div className={styles.label}>Last year</div>
        <IonItem
          className={styles.item}
          lines="none"
          button
          disabled={!isLastYearChanged}
          onClick={() =>
            dispatch(
              toggleTimePeriodSelection(
                TimePeriodType.LAST_YEAR
              )
            )
          }
        >
          <div className={styles.year}>
            <IonIcon
              className={styles.icon}
              icon={
                !value?.lastYear
                  ? ellipseOutline
                  : radioButtonOnOutline
              }
            />
            {lastYear}
          </div>
        </IonItem>
      </div>
    </React.Fragment>
  );
};

export default TimePeriodDropdown;
